import React, { FC, ReactNode, useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import './SwitchTransition.scss';

type SwitchTransitionProps = {
  state: boolean;
  elements: Array<string | ReactNode>;
  time?: number;
  className?: string;
};

const SwitchTransitionWrapper: FC<SwitchTransitionProps> = ({
  state,
  elements,
  time = 300,
  className = '',
}) => {
  const nodeRef1 = useRef(null);
  const nodeRef2 = useRef(null);

  return (
    <>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={state ? 'typeFIle' : 'manual'}
          nodeRef={state ? nodeRef1 : nodeRef2}
          timeout={time}
          classNames="fade"
          unmountOnExit
        >
          <div className={className} ref={state ? nodeRef1 : nodeRef2}>
            {state ? elements[0] : elements[1]}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </>
  );
};

export default SwitchTransitionWrapper;
